"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../../../form/utils");
var _dom = require("../dom");
var _default = exports["default"] = function _default(elementName) {
  var formName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var element = document.getElementById((0, _utils.getFieldUuid)(formName, elementName)) || document.getElementById(elementName);
  if (element && !(0, _dom.isElementVisible)(element)) {
    element.scrollIntoView();
  }
};